<template>
  <v-navigation-drawer v-model="drawer" absolute temporary right width="512">
    <v-container v-if="site">
      <v-row no-gutters>
        <v-col cols="1" class="d-flex d-sm-none">
          <v-btn icon @click="drawer = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="11" sm="12">
          <h1 class="text-center">
            {{ site.owner }} - {{ site.address.city }}
          </h1>
        </v-col>
      </v-row>

      <v-list dense>
        <v-list-item
          >{{ $t("site-details-owner") }} {{ site.owner }}</v-list-item
        >
        <v-list-item
          >{{ $t("site-details-city") }} {{ site.address.city }} ({{
            site.address.country
          }})</v-list-item
        >
        <v-list-item
          >{{ $t("site-details-status") }} {{ site.status }}</v-list-item
        >

        <template v-if="site.seeds.length > 0">
          <v-divider></v-divider>
          <v-subheader>{{ $t("site-details-crush-capacities") }}</v-subheader>
          <v-list-item
            v-for="(seed, index) in site.seeds"
            :key="`seed-${index}`"
          >
            <template v-if="seed.type === 'SOY_BEAN'">{{
              $t("site-details-soybean")
            }}</template>
            <template v-else-if="seed.type === 'RATE_SEED'">{{
              $t("site-details-rapeseed")
            }}</template>
            <template v-else-if="seed.type === 'SUNFLOWER_SEED'">{{
              $t("site-details-sunflower-seed")
            }}</template>
            {{ round(seed.quantity_per_day * site.business_days_per_year) }}
            {{ $t("site-details-kt-per-year") }}
            <template v-if="typeof seed.isDehulling !== 'undefined'">
              ({{
                !seed.isDehulling
                  ? $t("site-details-seed-dehulling-no")
                  : $t("site-details-seed-dehulling")
              }})
            </template>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-subheader>{{ $t("site-details-refining") }}</v-subheader>
        <v-list-item>
          <template v-if="site.refining.isRefining">
            {{
              round(site.refining.quantity_kt_day * site.business_days_per_year)
            }}
            {{ $t("site-details-kt-per-year") }}
          </template>
          <template v-else>{{ $t("site-details-refining-no") }}</template>
        </v-list-item>

        <v-divider></v-divider>
        <v-subheader>{{ $t("site-details-bottling") }}</v-subheader>
        <v-list-item>
          <template v-if="site.bottling.isBottling">
            {{
              round(site.bottling.quantity_kt_day * site.business_days_per_year)
            }}
            {{ $t("site-details-kt-per-year") }}
          </template>
          <template v-else>{{ $t("site-details-bottling-no") }}</template>
        </v-list-item>

        <v-divider></v-divider>
        <v-subheader>{{ $t("site-details-esterification") }}</v-subheader>
        <v-list-item v-if="!site.esterification.isEsterifying">{{
          $t("site-details-esterification-no")
        }}</v-list-item>
        <template v-else>
          <v-list-item
            v-for="(history, index) in site.esterification.history"
            :key="`esterification-history-${index}`"
            >{{
              $t("site-details-esterification-history", {
                year: history.year,
                operating: round(history.operating)
              })
            }}</v-list-item
          >
        </template>

        <v-divider></v-divider>
        <v-subheader>{{ $t("site-details-biomass-boiler") }}</v-subheader>
        <v-list-item>
          <template v-if="site.biomass_boiler">{{
            $t("site-details-biomass-boiler-yes")
          }}</template>
          <template v-else>{{ $t("site-details-biomass-boiler-no") }}</template>
        </v-list-item>

        <template v-if="site.meal_type.length > 0">
          <v-divider></v-divider>
          <v-subheader>{{ $t("site-details-meal-type") }}</v-subheader>
          <v-list-item
            v-for="(mealType, index) in site.meal_type"
            :key="`meal-type-${index}`"
            >{{ mealType }}</v-list-item
          >
        </template>

        <v-divider></v-divider>
        <v-subheader>{{ $t("site-details-extract-press") }}</v-subheader>
        <v-list-item>{{ site.extract_press }}</v-list-item>

        <template v-if="site.comments">
          <v-divider></v-divider>
          <v-subheader>{{ $t("site-details-comments") }}</v-subheader>
          <v-list-item>{{ site.comments }}</v-list-item>
        </template>
      </v-list>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SiteDrawer",

  data() {
    return {
      drawer: false,
      site: null
    };
  },

  methods: {
    setSite(site) {
      this.drawer = true;
      this.site = site;
    },

    round(value) {
      return Math.round(value * 100) / 100;
    }
  }
};
</script>
